(function (global) {
  'use strict';

  const SALE_FORM_PATH = '/api/paymentServiceProviders/altitudePay/createSaleForm';
  const LINK_SALE_FORM_PATH = '/api/paymentServiceProviders/altitudePay/createPaymentLinkSaleForm';
  // Creation states of a 202 that CryptoPay has not sent to the PSP yet: only an identical POST can move them on.
  const UNDISPATCHED_STATES = ['CheckAccepted', 'PendingCheck'];
  const RETURN_MESSAGE_TYPE = 'cryptopay.checkout.return';
  const POLL_INTERVAL_MS = 5000;
  const DEFAULT_RETRY_AFTER_S = 5;
  const CREATE_ATTEMPTS = 3;
  const EXPIRY_GRACE_MS = 60000;
  const POPUP_NAME = 'altitudepay_checkout';
  const POPUP_FEATURES = 'popup=yes,width=520,height=760';

  // Lottie data of the loading indicator (same animation as the pay-by-link page), embedded so it needs no extra request.
  const LOADING_ANIMATION = {"nm":"timer - 1","ddd":0,"h":400,"w":400,"meta":{"g":"@lottiefiles/toolkit-js 0.73.1"},"layers":[{"ty":4,"nm":"Layer 1/Objects Outlines","sr":1,"st":0,"op":96,"ip":0,"ln":"29","hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[44.5,44.5]},"s":{"a":0,"k":[420,420]},"p":{"a":0,"k":[200,200]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}},"shapes":[{"ty":"gr","nm":"Group 1","it":[{"ty":"sh","nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0.91,0.526],[0.525,-0.91],[0,0],[-0.91,-0.525],[-0.526,0.911]],"o":[[0.526,-0.909],[-0.91,-0.526],[0,0],[-0.526,0.911],[0.91,0.525],[0,0]],"v":[[4.458,-3.917],[3.762,-6.516],[1.163,-5.819],[-4.458,3.917],[-3.762,6.517],[-1.163,5.819]]}}},{"ty":"fl","nm":"Fill 1","c":{"a":0,"k":[0.8627,0.9725,1]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"p":{"a":0,"k":[62.488,12.661]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":0},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":4},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":54.999},{"s":[0],"t":57.999}]}}]},{"ty":"gr","nm":"Group 2","it":[{"ty":"sh","nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0.526,0.911],[0.911,-0.526],[0,0],[-0.525,-0.91],[-0.91,0.524]],"o":[[0.91,-0.525],[-0.525,-0.909],[0,0],[-0.911,0.526],[0.526,0.91],[0,0]],"v":[[5.819,-1.163],[6.516,-3.762],[3.916,-4.457],[-5.819,1.163],[-6.517,3.763],[-3.917,4.459]]}}},{"ty":"fl","nm":"Fill 1","c":{"a":0,"k":[0.7922,0.9451,1]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"p":{"a":0,"k":[75.841,26.012]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":4},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":8},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":57.999},{"s":[0],"t":60.999}]}}]},{"ty":"gr","nm":"Group 3","it":[{"ty":"sh","nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,1.051],[1.051,0],[0,0],[0,-1.05],[-1.052,0]],"o":[[1.051,0],[0,-1.05],[0,0],[-1.052,0],[0,1.051],[0,0]],"v":[[5.621,1.903],[7.525,0],[5.621,-1.902],[-5.621,-1.902],[-7.524,0],[-5.621,1.903]]}}},{"ty":"fl","nm":"Fill 1","c":{"a":0,"k":[0.7137,0.902,0.9882]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"p":{"a":0,"k":[80.724,44.249]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":8},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":12},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":60.999},{"s":[0],"t":63.999}]}}]},{"ty":"gr","nm":"Group 4","it":[{"ty":"sh","nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[-0.526,0.91],[0.909,0.525],[0,0],[0.525,-0.91],[-0.91,-0.525]],"o":[[0.91,0.526],[0.525,-0.91],[0,0],[-0.911,-0.526],[-0.524,0.91],[0,0]],"v":[[3.917,4.458],[6.517,3.762],[5.82,1.163],[-3.916,-4.458],[-6.517,-3.762],[-5.819,-1.163]]}}},{"ty":"fl","nm":"Fill 1","c":{"a":0,"k":[0.6353,0.8549,0.9765]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"p":{"a":0,"k":[75.839,62.487]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":12},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":16},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":63.999},{"s":[0],"t":66.999}]}}]},{"ty":"gr","nm":"Group 5","it":[{"ty":"sh","nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[-0.909,0.526],[0.526,0.911],[0,0],[0.91,-0.525],[-0.525,-0.91]],"o":[[0.525,0.91],[0.911,-0.525],[0,0],[-0.525,-0.911],[-0.91,0.526],[0,0]],"v":[[1.163,5.819],[3.762,6.516],[4.457,3.916],[-1.163,-5.819],[-3.763,-6.517],[-4.458,-3.917]]}}},{"ty":"fl","nm":"Fill 1","c":{"a":0,"k":[0.5608,0.8078,0.9765]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"p":{"a":0,"k":[62.488,75.839]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":16},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":20},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":66.999},{"s":[0],"t":69.999}]}}]},{"ty":"gr","nm":"Group 6","it":[{"ty":"sh","nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[-1.051,0],[0,1.052],[0,0],[1.05,0],[0,-1.052]],"o":[[0,1.052],[1.05,0],[0,0],[0,-1.052],[-1.051,0],[0,0]],"v":[[-1.903,5.62],[0,7.524],[1.902,5.62],[1.902,-5.621],[0,-7.524],[-1.903,-5.621]]}}},{"ty":"fl","nm":"Fill 1","c":{"a":0,"k":[0.4588,0.749,0.9882]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"p":{"a":0,"k":[44.25,80.726]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":20},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":24},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":69.999},{"s":[0],"t":72.999}]}}]},{"ty":"gr","nm":"Group 7","it":[{"ty":"sh","nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[-0.91,-0.526],[-0.525,0.91],[0,0],[0.91,0.524],[0.525,-0.91]],"o":[[-0.526,0.909],[0.91,0.525],[0,0],[0.526,-0.911],[-0.91,-0.525],[0,0]],"v":[[-4.458,3.917],[-3.762,6.517],[-1.163,5.819],[4.458,-3.916],[3.762,-6.516],[1.163,-5.819]]}}},{"ty":"fl","nm":"Fill 1","c":{"a":0,"k":[0.3647,0.6588,0.9569]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"p":{"a":0,"k":[26.012,75.837]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":24},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":28},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":72.999},{"s":[0],"t":75.999}]}}]},{"ty":"gr","nm":"Group 8","it":[{"ty":"sh","nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[-0.526,-0.91],[-0.911,0.526],[0,0],[0.526,0.91],[0.91,-0.526]],"o":[[-0.91,0.526],[0.525,0.91],[0,0],[0.911,-0.525],[-0.525,-0.91],[0,0]],"v":[[-5.819,1.162],[-6.516,3.762],[-3.916,4.457],[5.819,-1.163],[6.516,-3.763],[3.917,-4.458]]}}},{"ty":"fl","nm":"Fill 1","c":{"a":0,"k":[0.2824,0.5804,0.9373]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"p":{"a":0,"k":[12.661,62.488]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":28},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":32},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":75.999},{"s":[0],"t":78.999}]}}]},{"ty":"gr","nm":"Group 9","it":[{"ty":"sh","nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,-1.051],[-1.051,0],[0,0],[0,1.05],[1.052,0]],"o":[[-1.051,0],[0,1.05],[0,0],[1.052,0],[0,-1.051],[0,0]],"v":[[-5.621,-1.903],[-7.525,0.001],[-5.621,1.903],[5.621,1.903],[7.524,0.001],[5.621,-1.903]]}}},{"ty":"fl","nm":"Fill 1","c":{"a":0,"k":[0.1804,0.4784,0.9098]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"p":{"a":0,"k":[7.774,44.25]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":32},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":36},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":78.999},{"s":[0],"t":81.999}]}}]},{"ty":"gr","nm":"Group 10","it":[{"ty":"sh","nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0.526,-0.91],[-0.91,-0.525],[0,0],[-0.525,0.91],[0.91,0.526]],"o":[[-0.91,-0.526],[-0.526,0.91],[0,0],[0.91,0.526],[0.526,-0.91],[0,0]],"v":[[-3.917,-4.458],[-6.516,-3.762],[-5.82,-1.163],[3.917,4.458],[6.516,3.762],[5.819,1.163]]}}},{"ty":"fl","nm":"Fill 1","c":{"a":0,"k":[0.0824,0.4,0.9098]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"p":{"a":0,"k":[12.661,26.012]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":36},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":40},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":81.999},{"s":[0],"t":84.999}]}}]},{"ty":"gr","nm":"Group 11","it":[{"ty":"sh","nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0.91,-0.526],[-0.526,-0.911],[0,0],[-0.91,0.526],[0.526,0.91]],"o":[[-0.526,-0.91],[-0.91,0.525],[0,0],[0.525,0.911],[0.91,-0.525],[0,0]],"v":[[-1.163,-5.819],[-3.762,-6.516],[-4.458,-3.916],[1.163,5.819],[3.762,6.516],[4.458,3.917]]}}},{"ty":"fl","nm":"Fill 1","c":{"a":0,"k":[0,0.3176,0.7765]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"p":{"a":0,"k":[26.015,12.663]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":40},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":44},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":84.999},{"s":[0],"t":87.999}]}}]},{"ty":"gr","nm":"Group 12","it":[{"ty":"sh","nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[1.051,0],[0,-1.05],[0,0],[-1.05,0],[0,1.051]],"o":[[0,-1.05],[-1.05,0],[0,0],[0,1.051],[1.051,0],[0,0]],"v":[[1.903,-5.621],[-0.001,-7.525],[-1.903,-5.621],[-1.903,5.622],[-0.001,7.525],[1.903,5.622]]}}},{"ty":"fl","nm":"Fill 1","c":{"a":0,"k":[0,0.2275,0.6275]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"p":{"a":0,"k":[44.25,7.775]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":44},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":48},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":87.999},{"s":[0],"t":90.999}]}}]}],"ind":1}],"v":"5.7.0","fr":29.97,"op":96.6774193548387,"ip":0,"assets":[]};

  // Assets live next to this script (./assets/*.svg) unless assetsBaseUrl is passed.
  const SCRIPT_SRC = document.currentScript && document.currentScript.src;
  const DEFAULT_ASSETS_BASE = SCRIPT_SRC ? new URL('assets/', SCRIPT_SRC).href : 'assets/';

  const CSS = `
.apw-root{--apw-bg:#f5f7f9;--apw-text:#363636;--apw-muted:#9197b3;--apw-blue:#346bf0;--apw-link:#007aff;--apw-border:#e9e9e9;
  position:fixed;inset:0;z-index:2147483000;display:flex;overflow:auto;background:var(--apw-bg);color:var(--apw-text);
  font-family:'Apw Inter',system-ui,-apple-system,'Segoe UI',Roboto,sans-serif;-webkit-font-smoothing:antialiased;box-sizing:border-box}
.apw-root.apw-inline{position:relative;inset:auto;z-index:auto;min-height:100%}
.apw-root *{box-sizing:border-box}
.apw-close{position:absolute;right:20px;top:20px;width:36px;height:36px;margin:0;border:0;border-radius:50%;background:var(--apw-bg);color:var(--apw-muted);
  display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0}
.apw-close svg{width:14px;height:14px;display:block}
.apw-close:hover{background:#e6ebef;color:var(--apw-text)}
.apw-close:active{transform:scale(.92)}
.apw-card{margin:auto;width:min(1055px,calc(100% - 32px));min-height:800px;background:#fff;border-radius:32px;padding:64px 24px;
  display:flex;flex-direction:column;align-items:center;justify-content:center}
.apw-sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}
.apw-brand{width:105px;height:120px;display:block}
.apw-illustration{width:72px;height:72px;display:block;margin-top:24px}
.apw-illustration+.apw-btn{margin-top:24px}
.apw-fixed{display:flex;flex-direction:column;align-items:center}
.apw-amount{margin:40px 0 0;font-size:56px;line-height:68px;font-weight:700;color:var(--apw-text);text-align:center;word-break:break-word}
.apw-amount-field{margin:40px 0 0;display:flex;width:min(380px,100%);height:80px;border-radius:40px;background:rgba(245,247,249,.8);overflow:hidden}
.apw-amount-prefix{flex:0 0 88px;display:flex;align-items:center;justify-content:center;background:rgba(230,235,239,.8);
  font-size:48px;font-weight:700;color:var(--apw-text)}
.apw-amount-input{flex:1;min-width:0;border:0;outline:0;background:transparent;padding:0 16px;font:700 48px/1 'Apw Inter',sans-serif;color:var(--apw-text)}
.apw-amount-input::placeholder{color:#c3c8d4;font-weight:700}
.apw-limits{margin:16px 0 0;font-size:16px;color:var(--apw-muted);text-align:center}
.apw-limits b{font-weight:500}
.apw-limits.apw-error{color:#e5484d}
.apw-pill{margin:24px 0 0;display:inline-flex;align-items:center;justify-content:center;gap:8px;width:180px;height:40px;border-radius:32px;
  background:rgba(26,177,46,.2);font-size:16px;font-weight:600;color:#000}
.apw-pill img{width:10px;height:10px;display:block}
.apw-btn{margin:40px 0 0;display:flex;align-items:center;justify-content:center;width:min(470px,100%);height:56px;border:0;border-radius:32px;
  background:linear-gradient(90deg,#346bf0,#568af7);color:#fff;font:600 16px/1 'Apw Inter',sans-serif;text-transform:uppercase;cursor:pointer;padding:0}
.apw-btn:disabled{opacity:.45;cursor:not-allowed}
.apw-btn.apw-solid{width:min(385px,100%);margin:0;background:var(--apw-blue);font-size:18px;font-weight:500;text-transform:none}
.apw-btn.apw-outline{width:min(385px,100%);margin:0;background:transparent;border:1px solid var(--apw-link);color:var(--apw-blue);font-size:18px;font-weight:500;text-transform:none}
.apw-terms{margin:24px 0 0;display:flex;align-items:center;gap:12px;font-size:14px;color:#292626;cursor:pointer;max-width:100%}
.apw-terms a{color:var(--apw-link);text-decoration:none}
.apw-box{position:relative;flex:0 0 24px;width:24px;height:24px;border:1px solid var(--apw-border);border-radius:6px;background:#fff}
.apw-box img{position:absolute;left:3px;top:3px;width:16.5px;height:15px;display:none}
.apw-terms input:checked+.apw-box img{display:block}
.apw-terms input:focus-visible+.apw-box{outline:2px solid var(--apw-blue);outline-offset:2px}
.apw-panel{width:min(548px,100%);margin:32px 0 0;padding:31px 24px 0;border-radius:12px;background:rgba(245,247,249,.72)}
.apw-panel h3{margin:0 0 14px;font-size:14px;font-weight:600;color:#000;text-transform:uppercase}
.apw-row{display:flex;align-items:center;justify-content:space-between;gap:16px;min-height:58px;font-size:14px}
.apw-row dt{color:var(--apw-muted);margin:0}
.apw-row dd{margin:0;font-size:16px;font-weight:600;color:var(--apw-text);display:flex;align-items:center;gap:8px;text-align:right}
.apw-row dd img{width:10px;height:10px;display:block}
.apw-sep{height:1px;background:var(--apw-line) center/100% 100% no-repeat}
.apw-panel .apw-row:last-child{min-height:60px}
.apw-spin{width:18px;height:18px;border:2px solid rgba(255,255,255,.4);border-top-color:#fff;border-radius:50%;animation:apw-rot .8s linear infinite}
@keyframes apw-rot{to{transform:rotate(360deg)}}

.apw-checkout{width:100%;max-width:560px;display:flex;flex-direction:column;align-items:center;gap:16px}
.apw-checkout h2{margin:0;font-size:24px;font-weight:600;color:#000}
.apw-frame-wrap{position:relative;width:100%;height:min(640px,calc(100vh - 280px));min-height:420px;border:1px solid var(--apw-border);border-radius:12px;overflow:hidden;background:#fff}
.apw-frame{position:absolute;inset:0;width:100%;height:100%;border:0;display:block}
.apw-frame-note{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;padding:24px;text-align:center;
  background:rgba(245,247,249,.96);font-size:16px;line-height:24px}
.apw-link{border:0;background:none;padding:0;margin:0;color:var(--apw-link);font:500 14px/20px 'Apw Inter',sans-serif;cursor:pointer}
.apw-actions-row{display:flex;gap:24px;flex-wrap:wrap;justify-content:center}
.apw-hint{margin:0;font-size:14px;color:var(--apw-muted);text-align:center}

.apw-card:has(.apw-result){padding:64px 40px 40px}
.apw-result{width:100%;display:grid;grid-template-columns:minmax(0,1fr) 460px;grid-template-areas:"hero panel" "actions panel";
  column-gap:28px;align-items:center}
.apw-hero{grid-area:hero;display:flex;flex-direction:column;align-items:center;text-align:center;align-self:end}
.apw-actions{grid-area:actions;display:flex;flex-direction:column;align-items:center;gap:24px;margin-top:48px;align-self:start}
.apw-icon{position:relative;width:112px;height:112px}
.apw-icon .apw-ring{position:absolute;left:0;top:0;width:112px;height:112px;display:block}
.apw-icon .apw-disc{position:absolute;left:12px;top:12px;width:88px;height:88px;display:block}
.apw-icon .apw-glyph{position:absolute;left:12px;top:12px;width:88px;height:88px;display:block;overflow:visible}
.apw-title{margin:24px 0 0;font-size:32px;line-height:40px;font-weight:600;color:var(--apw-text)}
.apw-text{margin:16px 0 0;max-width:420px;font-size:18px;line-height:30px;color:var(--apw-text)}
.apw-summary{grid-area:panel;align-self:center;width:100%;min-height:680px;padding:48px 40px 40px;border-radius:12px;background:rgba(245,247,249,.88)}
.apw-summary h3{margin:0 0 37px;font-size:24px;line-height:29px;font-weight:600;color:#000;text-transform:none}
.apw-summary .apw-row{display:block;min-height:0;padding:24px 0;font-size:16px;line-height:19px}
.apw-summary .apw-row:first-of-type{padding-top:0}
.apw-summary .apw-row dd{display:block;margin-top:12px;font-size:18px;line-height:22px;text-align:left}
.apw-summary .apw-row dt{font-size:16px}

/* ---- motion ---- */
/* the keyframes deliberately have no "to" step, so they end on the element's own opacity (e.g. a disabled button's .45) */
@keyframes apw-fade{from{opacity:0}}
@keyframes apw-fadeout{to{opacity:0}}
@keyframes apw-rise{from{opacity:0;transform:translateY(28px) scale(.98)}}
@keyframes apw-up{from{opacity:0;transform:translateY(16px)}}
@keyframes apw-pop{0%{opacity:0;transform:scale(.4)}60%{opacity:1;transform:scale(1.08)}100%{transform:scale(1)}}
@keyframes apw-ripple{0%{opacity:.5;transform:scale(1)}100%{opacity:0;transform:scale(1.7)}}
@keyframes apw-shake{0%,100%{transform:translateX(0)}20%{transform:translateX(-8px)}40%{transform:translateX(7px)}60%{transform:translateX(-5px)}80%{transform:translateX(3px)}}
@keyframes apw-check{0%{transform:scale(0) rotate(-20deg)}70%{transform:scale(1.2) rotate(0)}100%{transform:scale(1)}}
@keyframes apw-shimmer{to{background-position:-200% 0}}

.apw-root{animation:apw-fade .25s ease-out}
.apw-root.apw-leaving{animation:apw-fadeout .2s ease-in forwards;pointer-events:none}
.apw-card{animation:apw-rise .55s cubic-bezier(.22,1,.36,1) backwards}
.apw-close{animation:apw-close-in .45s .3s cubic-bezier(.34,1.56,.64,1) backwards}
@keyframes apw-close-in{from{opacity:0;transform:scale(.5)}}

/* a screen change replays the staggered entrance (see render()) */
.apw-enter>*{animation:apw-up .55s cubic-bezier(.22,1,.36,1) backwards}
.apw-enter>:nth-child(2){animation-delay:.05s}
.apw-enter>:nth-child(3){animation-delay:.1s}
.apw-enter>:nth-child(4){animation-delay:.15s}
.apw-enter>:nth-child(5){animation-delay:.2s}
.apw-enter>:nth-child(6){animation-delay:.25s}
.apw-enter>:nth-child(7){animation-delay:.3s}
.apw-enter>.apw-result{animation:none}
.apw-enter .apw-hero{animation:apw-up .55s cubic-bezier(.22,1,.36,1) backwards}
.apw-enter .apw-summary{animation:apw-up .55s .12s cubic-bezier(.22,1,.36,1) backwards}
.apw-enter .apw-actions{animation:apw-up .55s .24s cubic-bezier(.22,1,.36,1) backwards}
.apw-enter .apw-panel>:nth-child(n),.apw-enter .apw-summary>:nth-child(n){animation:apw-fade .45s backwards}
.apw-enter .apw-panel>:nth-child(2),.apw-enter .apw-summary>:nth-child(2){animation-delay:.3s}
.apw-enter .apw-panel>:nth-child(4),.apw-enter .apw-summary>:nth-child(4){animation-delay:.38s}
.apw-enter .apw-panel>:nth-child(6),.apw-enter .apw-summary>:nth-child(6){animation-delay:.46s}
.apw-enter .apw-summary>:nth-child(8){animation-delay:.54s}

.apw-illustration svg,.apw-illustration img{width:100%;height:100%;display:block}
/* "Active" indicator: a steady dot with a ring that expands and fades (a ping, not a breathing pulse) */
.apw-panel .apw-row dd{line-height:20px}
.apw-dot{position:relative;display:block;flex:0 0 10px;align-self:flex-start;width:10px;height:10px;margin:6px 0 0}
.apw-dot img{display:block;width:10px;height:10px}
.apw-dot::after{content:'';position:absolute;inset:0;border-radius:50%;background:#1ab12e;opacity:0;animation:apw-ping 2s cubic-bezier(0,0,.2,1) infinite}
@keyframes apw-ping{0%{opacity:.55;transform:scale(1)}70%,100%{opacity:0;transform:scale(2.8)}}

.apw-btn,.apw-close,.apw-box,.apw-amount-field{transition:transform .2s ease,box-shadow .25s ease,opacity .2s ease,background-color .2s ease,border-color .2s ease,color .2s ease}
.apw-btn:not(:disabled):hover{transform:translateY(-2px);box-shadow:0 10px 24px rgba(52,107,240,.32)}
.apw-btn:not(:disabled):active{transform:translateY(0) scale(.98);box-shadow:none}
.apw-btn.apw-outline:not(:disabled):hover{background:rgba(52,107,240,.08);box-shadow:none}
.apw-btn.apw-outline:not(:disabled):focus-visible{box-shadow:0 0 0 3px rgba(52,107,240,.3)}
.apw-btn,.apw-close,.apw-link{-webkit-tap-highlight-color:transparent}
.apw-btn:focus,.apw-close:focus,.apw-link:focus{outline:none}
.apw-btn:focus-visible,.apw-close:focus-visible{box-shadow:0 0 0 3px rgba(52,107,240,.3)}
.apw-link:focus-visible{text-decoration:underline}
.apw-terms:hover .apw-box{border-color:var(--apw-blue)}
.apw-terms input:checked+.apw-box img{animation:apw-check .35s cubic-bezier(.34,1.56,.64,1)}
.apw-amount-field:focus-within{box-shadow:0 0 0 3px rgba(52,107,240,.25)}
.apw-link{transition:opacity .2s ease}
.apw-link:hover{opacity:.7}
.apw-limits.apw-error{animation:apw-shake .4s}
.apw-limits[role=alert]{animation:apw-up .35s ease-out}

.apw-icon::after{content:'';position:absolute;inset:0;border-radius:50%;border:2px solid var(--apw-c,#346bf0);opacity:0;animation:apw-ripple 1.4s .45s ease-out 2 backwards}
.apw-icon.apw-bad{--apw-c:#e5484d;animation:apw-shake .5s .55s}
.apw-icon .apw-ring{animation:apw-pop .6s cubic-bezier(.34,1.56,.64,1) backwards}
.apw-icon .apw-disc{animation:apw-pop .6s .12s cubic-bezier(.34,1.56,.64,1) backwards}
.apw-icon .apw-glyph path{stroke-dasharray:1;animation:apw-draw .45s .35s ease-out backwards}
@keyframes apw-draw{from{stroke-dashoffset:1}to{stroke-dashoffset:0}}

.apw-frame-wrap::before{content:'';position:absolute;inset:0;background:linear-gradient(100deg,#f5f7f9 30%,#fff 50%,#f5f7f9 70%) 0 0/200% 100%;animation:apw-shimmer 1.4s linear infinite}
.apw-frame-wrap::after{content:'';position:absolute;left:50%;top:50%;width:32px;height:32px;margin:-16px 0 0 -16px;border:3px solid rgba(52,107,240,.2);border-top-color:var(--apw-blue);border-radius:50%;animation:apw-rot .8s linear infinite}
.apw-frame-wrap.apw-loaded::before,.apw-frame-wrap.apw-loaded::after{display:none}
.apw-frame{opacity:0;transition:opacity .35s ease}
.apw-frame-wrap.apw-loaded .apw-frame{opacity:1}
.apw-frame-note{animation:apw-fade .3s ease-out}

@media (prefers-reduced-motion:reduce){
  .apw-root,.apw-root *,.apw-root *::before,.apw-root *::after{animation-duration:.001ms!important;animation-delay:0s!important;animation-iteration-count:1!important;transition-duration:.001ms!important}
}

/* ---- floating window: no page background, the host page stays visible and clickable ---- */
.apw-root{padding:16px;align-items:center;justify-content:center;overflow:auto;background:rgba(15,23,42,.55);backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px)}
.apw-root:focus{outline:none}
/* an inline widget (options.container) has no backdrop and does not block the page */
.apw-root.apw-inline{background:none;backdrop-filter:none;-webkit-backdrop-filter:none;overflow:visible;pointer-events:none}
.apw-root.apw-inline>*{pointer-events:auto}
.apw-window{position:relative;zoom:.85;width:min(680px,calc((100vw - 32px) / .85));transition:width .4s cubic-bezier(.22,1,.36,1)}
.apw-window.apw-wide{width:min(980px,calc((100vw - 32px) / .85))}
.apw-root.apw-inline{padding:0;min-height:0}
.apw-root.apw-inline .apw-window{margin:0 auto}
.apw-card{min-height:760px;padding-top:72px}
.apw-checkout .apw-frame-wrap{height:min(480px,calc((100vh - 32px) / .85 - 440px))}
.apw-checkout .apw-brand{margin-bottom:12px}
.apw-close{z-index:1}
.apw-card{width:100%;margin:0;max-height:calc((100vh - 32px) / .85);overflow:auto;
  box-shadow:0 24px 64px rgba(16,24,40,.2),0 4px 14px rgba(16,24,40,.08)}
/* In a short window the card scrolls instead of squeezing its children (the button lost its height). The spacers keep the content
   centred when it fits and let it scroll from the top when it does not, which justify-content:center cannot do. */
.apw-card{justify-content:flex-start}
.apw-card::before,.apw-card::after{content:'';flex:1 0 0}
.apw-card>*{flex-shrink:0}

@media (max-width:720px){
  .apw-window{zoom:1;width:min(335px,100%)}
  .apw-brand{width:70px;height:80px}
  .apw-close{right:12px;top:12px}
  .apw-card{min-height:0;max-height:calc(100vh - 32px);border-radius:12px;padding:40px 20px}
  .apw-amount{font-size:40px;line-height:48px;margin-top:24px}
  .apw-pill{width:160px;height:32px;border-radius:24px;font-size:14px;margin-top:16px}
  .apw-amount-field{height:64px;margin-top:24px}
  .apw-amount-prefix{flex-basis:64px;font-size:36px}
  .apw-amount-input{font-size:36px}
  .apw-illustration{width:72px;height:72px}
  .apw-btn{margin-top:32px}
  .apw-panel{margin-top:32px;padding:20px 20px 0}
  .apw-card:has(.apw-result){padding:40px 20px}
  .apw-summary{padding:20px;min-height:0}
  .apw-row dd{font-size:14px}
  .apw-result{display:flex;flex-direction:column;align-items:stretch;max-width:none}
  .apw-hero{order:1}
  .apw-summary{order:2;margin-top:24px}
  .apw-actions{order:3;margin-top:24px;align-self:stretch}
  .apw-title{font-size:24px;line-height:32px}
  .apw-text{font-size:16px;line-height:24px}
  .apw-summary h3{font-size:20px;margin-bottom:16px}
  .apw-summary .apw-row{display:flex;padding:14px 0;font-size:14px}
  .apw-summary .apw-row dt{font-size:14px}
  .apw-summary .apw-row dd{margin:0;font-size:14px;text-align:right}
  .apw-btn.apw-solid,.apw-btn.apw-outline{width:100%;font-size:16px}
  .apw-frame-wrap{height:calc(100vh - 260px);min-height:360px}
}`;

  // ---------------------------------------------------------------- helpers

  function h(tag, attrs, ...children) {
    const el = document.createElement(tag);
    if (attrs) {
      for (const [key, value] of Object.entries(attrs)) {
        if (value === undefined || value === null || value === false) continue;
        if (key === 'class') el.className = value;
        else if (key.startsWith('on') && typeof value === 'function') el.addEventListener(key.slice(2), value);
        else el.setAttribute(key, value === true ? '' : value);
      }
    }
    for (const child of children.flat()) {
      if (child === undefined || child === null || child === false) continue;
      el.append(child.nodeType ? child : document.createTextNode(String(child)));
    }
    return el;
  }

  // The check / cross in the design are text glyphs whose rendering depends on the font, so they are drawn as
  // SVG paths centred on the 88px disc instead.
  function glyph(success) {
    const NS = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'apw-glyph');
    svg.setAttribute('viewBox', '0 0 88 88');
    svg.setAttribute('width', '88');
    svg.setAttribute('height', '88');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS(NS, 'path');
    path.setAttribute('stroke', '#fff');
    path.setAttribute('stroke-width', success ? '7' : '8');
    path.setAttribute('stroke-linecap', success ? 'round' : 'butt');
    path.setAttribute('stroke-linejoin', 'round');
    path.setAttribute('pathLength', '1');
    path.setAttribute('d', success ? 'M27.5 44.5 L38 55 L62 33' : 'M31 31 L57 57 M57 31 L31 57');
    svg.appendChild(path);
    return svg;
  }

  // lottie-web (the light, SVG-only build) is self-hosted next to the widget assets and loaded on first use.
  let lottiePromise = null;
  function loadLottie(src) {
    if (global.lottie) return Promise.resolve(global.lottie);
    if (!lottiePromise) {
      lottiePromise = new Promise((resolve, reject) => {
        const script = h('script', { src, async: true });
        script.onload = () => resolve(global.lottie);
        script.onerror = () => { lottiePromise = null; script.remove(); reject(new Error('lottie failed to load')); };
        document.head.appendChild(script);
      });
    }
    return lottiePromise;
  }

  // A "#" placeholder link does nothing (no new tab, no jump); a real URL opens in a new tab.
  function docLink(url, label) {
    if (url === '#') return h('a', { href: '#', onclick: (event) => event.preventDefault() }, label);
    return h('a', { href: url, target: '_blank', rel: 'noopener noreferrer' }, label);
  }

  function closeIcon() {
    const NS = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 14 14');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS(NS, 'path');
    path.setAttribute('d', 'M2 2 L12 12 M12 2 L2 12');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '2');
    path.setAttribute('stroke-linecap', 'round');
    svg.appendChild(path);
    return svg;
  }

  // Inter is self-hosted in assets/fonts (SIL OFL 1.1), so the widget makes no requests to third-party font servers.
  function ensureStyles(assetsBase) {
    if (!document.getElementById('apw-styles')) {
      const style = h('style', { id: 'apw-styles' });
      style.textContent = CSS;
      document.head.appendChild(style);
    }
    if (!document.getElementById('apw-fonts')) {
      const faces = [400, 500, 600, 700].map((weight) => {
        const url = new URL(`fonts/inter-latin-${weight}.woff2`, assetsBase).href;
        return `@font-face{font-family:'Apw Inter';font-style:normal;font-weight:${weight};font-display:swap;src:url('${url}') format('woff2')}`;
      });
      const style = h('style', { id: 'apw-fonts' });
      style.textContent = faces.join('\n');
      document.head.appendChild(style);
    }
  }

  function sleep(ms, signal) {
    return new Promise((resolve, reject) => {
      if (signal && signal.aborted) return reject(new DOMException('Aborted', 'AbortError'));
      const timer = setTimeout(resolve, ms);
      if (signal) {
        signal.addEventListener('abort', () => {
          clearTimeout(timer);
          reject(new DOMException('Aborted', 'AbortError'));
        }, { once: true });
      }
    });
  }

  function formatMoney(amount, currency) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(amount);
    } catch {
      return `${formatNumber(amount)} ${currency}`;
    }
  }

  function formatNumber(amount) {
    return Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: false });
  }

  function currencySymbol(currency) {
    try {
      const part = new Intl.NumberFormat('en-US', { style: 'currency', currency }).formatToParts(0)
        .find((x) => x.type === 'currency');
      return part ? part.value : currency;
    } catch {
      return currency;
    }
  }

  function currencyName(currency) {
    try {
      return new Intl.DisplayNames(['en'], { type: 'currency' }).of(currency) || currency;
    } catch {
      return currency;
    }
  }

  function formatDate(date) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false,
    }).formatToParts(date).map((x) => [x.type, x.value]));
    return `${parts.day} ${parts.month} ${parts.year} ${parts.hour}:${parts.minute}`;
  }

  function newRequestId() {
    if (global.crypto && typeof global.crypto.randomUUID === 'function') return global.crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  function parseAmount(text) {
    const value = Number(text);
    return Number.isFinite(value) ? value : NaN;
  }

  function safeHttpUrl(value, base) {
    try {
      const url = new URL(value, base);
      return url.protocol === 'https:' || url.protocol === 'http:' ? url : null;
    } catch {
      return null;
    }
  }

  // ---------------------------------------------------------------- widget

  /**
   * Opens the AltitudePay checkout widget.
   * @param {Object} options
   * @param {string} options.apiBaseUrl - backend origin, e.g. 'https://api.example.com'
   * @param {string} [options.paymentLinkToken] - selects Payment by Link mode (merchantId/merchantPaymentId are then not used)
   * @param {number|string} [options.merchantId] - required without paymentLinkToken
   * @param {string|((attempt:number)=>string)} [options.merchantPaymentId] - required without paymentLinkToken; unique per payment attempt
   * @param {string} options.currency - ISO code, e.g. 'EUR'
   * @param {number} [options.amount] - when omitted the payer enters it (see minAmount/maxAmount)
   * @param {string} [options.description]
   * @param {Object} options.payer - firstName, lastName, email, phone, address, city, postalCode, country, [state]
   * @param {number} [options.minAmount=1]
   * @param {number} [options.maxAmount=10000]
   * @param {string} [options.termsUrl]
   * @param {string} [options.privacyUrl]
   * @param {string} [options.dashboardUrl] - target of "Go back"; without it the button closes the widget
   * @param {HTMLElement} [options.container] - render inline instead of a full-screen overlay
   * @param {string} [options.assetsBaseUrl]
   * @param {(result:Object)=>void} [options.onComplete] - fires once the backend reports a final result
   * @param {(info:Object)=>void} [options.onClose] - fires when the UI is closed (not a payment failure)
   * @returns {{close:()=>void}}
   */
  function open(options) {
    const opts = normalizeOptions(options);
    ensureStyles(opts.assetsBaseUrl);

    const assets = (name) => new URL(name, opts.assetsBaseUrl).href;
    const abort = new AbortController();
    const signal = abort.signal;

    const isLink = Boolean(opts.paymentLinkToken);

    const state = {
      screen: 'summary',
      frozen: null, // Payment by Link: { core, body } of the request that belongs to state.requestId
      replayTimer: null,
      replaying: false,
      unresolved: false,
      amount: opts.amount,
      attempt: 1,
      requestId: newRequestId(),
      creating: false,
      agreed: false,
      session: null, // { paymentOrderId, checkoutUrl, checkoutOrigin, statusUrl, expiresAt }
      pollTimer: null,
      polling: false,
      popup: null,
      popupWatch: null,
      finished: false,
      closed: false,
    };

    // ------------------------------------------------------------ DOM shell

    const root = h('div', {
      class: 'apw-root' + (opts.container ? ' apw-inline' : ''),
      role: 'dialog', 'aria-label': 'Payment', 'aria-modal': opts.container ? null : 'true', tabindex: '-1',
    });
    root.style.setProperty('--apw-line', `url("${assets('line.svg')}")`);
    const card = h('main', { class: 'apw-card' });
    const windowEl = h('div', { class: 'apw-window' },
      h('button', { class: 'apw-close', type: 'button', 'aria-label': 'Close', onclick: close }, closeIcon()),
      card);
    root.append(windowEl);

    // A compact floating window: the host page is neither dimmed nor locked.
    const host = opts.container || document.body;
    host.appendChild(root);

    // The overlay dims the page, blocks clicks and scrolling behind it, and keeps keyboard focus inside the widget.
    const previousOverflow = document.body.style.overflow;
    if (!opts.container) {
      document.body.style.overflow = 'hidden';
      root.focus({ preventScroll: true });
      document.addEventListener('focusin', keepFocusInside);
    }
    function keepFocusInside(event) {
      if (!root.contains(event.target)) root.focus({ preventScroll: true });
    }

    window.addEventListener('message', onMessage);

    render();

    // ------------------------------------------------------------ rendering

    // The loading indicator is the lottie animation; the static SVG shows until it is ready or if it cannot load.
    function createLoader(busy) {
      const fallback = h('img', { src: assets('objects-72.svg'), alt: '' });
      const box = h('div', { class: 'apw-illustration', role: 'img', 'aria-label': 'Loading' }, fallback);
      loadLottie(assets('lottie_light.min.js')).then((lottie) => {
        if (state.closed || !box.isConnected) return;
        const anim = lottie.loadAnimation({
          container: box, renderer: 'svg', loop: true, autoplay: true, animationData: LOADING_ANIMATION,
        });
        anim.setSpeed(busy ? 2.5 : 1);
        anim.addEventListener('DOMLoaded', () => fallback.remove());
        state.loader = anim;
      }).catch(() => { /* the static fallback stays */ });
      return box;
    }

    function destroyLoader() {
      if (state.loader) state.loader.destroy();
      state.loader = null;
    }

    function render() {
      if (state.closed) return;
      destroyLoader();
      // The two-column result screens need more room than the payment steps.
      windowEl.classList.toggle('apw-wide', state.screen === 'success' || state.screen === 'failed');
      // Replay the entrance animation only when the screen itself changes, not on in-place updates.
      if (state.renderedScreen !== state.screen) {
        state.renderedScreen = state.screen;
        card.classList.remove('apw-enter');
        void card.offsetWidth;
        card.classList.add('apw-enter');
      }
      switch (state.screen) {
        case 'checkout': return renderCheckout();
        case 'success': return renderResult(true);
        case 'failed': return renderResult(false);
        default: return renderSummary();
      }
    }

    function picture(base, mobileBase, className) {
      return h('picture', null,
        h('source', { media: '(max-width: 720px)', srcset: assets(mobileBase) }),
        h('img', { class: className, src: assets(base), alt: '' }));
    }

    function summaryRow(label, value, withDot) {
      return h('div', { class: 'apw-row' },
        h('dt', null, label),
        h('dd', null, value, withDot ? h('span', { class: 'apw-dot' }, h('img', { src: assets('dot-active.svg'), alt: '' })) : null));
    }

    function renderSummary() {
      const editable = opts.amount === undefined;
      const amountValid = Number.isFinite(state.amount) && state.amount >= opts.minAmount && state.amount <= opts.maxAmount;

      const proceed = h('button', { class: 'apw-btn', type: 'button', onclick: startPayment },
        state.creating ? h('span', { class: 'apw-spin', 'aria-label': 'Processing' }) : 'Proceed to payment');
      const refreshProceed = () => { proceed.disabled = state.creating || !state.agreed || !amountValid; };

      const totalValue = h('dd', null, state.amount !== undefined && Number.isFinite(state.amount) ? formatNumber(state.amount) : '—');
      // A fixed amount is plain text; the grey pill field exists only when the payer types the amount.
      const amountBlock = editable
        ? buildAmountField()
        : h('div', { class: 'apw-fixed' },
          h('p', { class: 'apw-amount' }, formatMoney(state.amount, opts.currency)));

      function buildAmountField() {
        const input = h('input', {
          class: 'apw-amount-input', type: 'text', inputmode: 'decimal', autocomplete: 'off', placeholder: '0.00',
          'aria-label': 'Amount', value: state.amountText || '', disabled: state.creating,
        });
        const limits = h('p', { class: 'apw-limits' },
          'min. ', h('b', null, formatNumber(opts.minAmount)), ' - max. ', h('b', null, formatNumber(opts.maxAmount)));
        input.addEventListener('input', () => {
          if (!/^\d*(\.\d{0,2})?$/.test(input.value)) {
            input.value = state.amountText || '';
            return;
          }
          state.amountText = input.value;
          state.amount = input.value === '' ? undefined : parseAmount(input.value);
          const ok = Number.isFinite(state.amount) && state.amount >= opts.minAmount && state.amount <= opts.maxAmount;
          limits.classList.toggle('apw-error', input.value !== '' && !ok);
          totalValue.textContent = Number.isFinite(state.amount) ? formatNumber(state.amount) : '—';
          proceed.disabled = state.creating || !state.agreed || !ok;
        });
        const wrap = h('div', null,
          h('div', { class: 'apw-amount-field' }, h('span', { class: 'apw-amount-prefix' }, currencySymbol(opts.currency)), input),
          limits);
        wrap.style.display = 'flex';
        wrap.style.flexDirection = 'column';
        wrap.style.alignItems = 'center';
        return wrap;
      }

      const checkbox = h('input', { type: 'checkbox', class: 'apw-sr', checked: state.agreed, disabled: state.creating });
      checkbox.addEventListener('change', () => { state.agreed = checkbox.checked; refreshProceed(); });

      const terms = h('label', { class: 'apw-terms' },
        checkbox,
        h('span', { class: 'apw-box' }, h('img', { src: assets('check.svg'), alt: '' })),
        h('span', null,
          'I agree to the ',
          docLink(opts.termsUrl, 'Terms & Conditions'),
          ' and ',
          docLink(opts.privacyUrl, 'Privacy Policy'),
          '.'));

      const panel = h('section', { class: 'apw-panel' },
        h('h3', null, 'Payment summary'),
        h('div', { class: 'apw-row' }, h('dt', null, 'Total amount:'), totalValue),
        h('div', { class: 'apw-sep' }),
        summaryRow('Currency:', currencyName(opts.currency)),
        h('div', { class: 'apw-sep' }),
        summaryRow('Status', 'Active', true));

      refreshProceed();
      card.replaceChildren(
        h('img', { class: 'apw-brand', src: assets('logo-lg.svg'), alt: 'Orca' }),
        amountBlock,
        createLoader(state.creating),
        proceed,
        terms,
        panel);

      if (state.error) {
        card.insertBefore(h('p', { class: 'apw-limits apw-error', role: 'alert' }, state.error), terms);
      }
    }

    function renderCheckout() {
      const session = state.session;
      const frameWrap = h('div', { class: 'apw-frame-wrap' });

      const frame = h('iframe', {
        class: 'apw-frame', title: 'Secure payment form', allow: 'payment *',
      });
      state.frame = frame;
      frame.addEventListener('load', () => frameWrap.classList.add('apw-loaded'));

      const popupMode = Boolean(state.popup && !state.popup.closed);
      if (!popupMode) frame.src = session.checkoutUrl;
      frameWrap.append(frame);

      if (popupMode || state.popupNote) {
        frameWrap.append(h('div', { class: 'apw-frame-note' },
          h('p', { class: 'apw-hint' }, popupMode
            ? 'The payment form is open in a separate window.'
            : 'The payment window was closed. We are still checking the payment status.'),
          h('div', { class: 'apw-actions-row' },
            popupMode
              ? h('button', { class: 'apw-link', type: 'button', onclick: () => state.popup && state.popup.focus() }, 'Switch to payment window')
              : h('button', { class: 'apw-link', type: 'button', onclick: reopenEmbedded }, 'Continue here'),
            !popupMode ? h('button', { class: 'apw-link', type: 'button', onclick: openPopup }, 'Open in a new window') : null)));
      }

      card.replaceChildren(h('div', { class: 'apw-checkout' },
        h('img', { class: 'apw-brand', src: assets('logo-lg.svg'), alt: 'Orca' }),
        h('h2', null, `Pay ${formatMoney(state.amount, opts.currency)}`),
        frameWrap,
        h('p', { class: 'apw-hint' },
          'Card details are entered on the secure payment provider form. ',
          h('button', { class: 'apw-link', type: 'button', onclick: openPopup }, 'Form not loading? Open it in a new window'))));
    }

    function renderResult(success) {
      const result = state.result || {};
      const symbolRow = (label, value) => h('div', { class: 'apw-row' }, h('dt', null, label), h('dd', null, value));
      const rows = success
        ? [
          ['Order ID', `#${result.paymentOrderId}`],
          ['Total Paid', formatNumber(state.amount)],
          ['Currency', currencyName(opts.currency).toUpperCase()],
          ['Date', formatDate(state.finishedAt || new Date())],
        ]
        : [
          ['Error Code:', `#${result.code || 'ERROR'}`],
          ['Attempted Amount', Number.isFinite(state.amount) ? formatNumber(state.amount) : '—'],
          ['Currency', currencyName(opts.currency).toUpperCase()],
          ['Date', formatDate(state.finishedAt || new Date())],
        ];

      const summary = h('section', { class: 'apw-summary' }, h('h3', null, 'Order Summary'));
      rows.forEach(([label, value], index) => {
        if (index) summary.append(h('div', { class: 'apw-sep' }));
        summary.append(symbolRow(label, value));
      });

      const dashboard = h('button', { class: 'apw-btn apw-outline', type: 'button', onclick: goToDashboard }, 'Go back');
      const actions = h('div', { class: 'apw-actions' },
        success || state.unresolved ? null : h('button', { class: 'apw-btn apw-solid', type: 'button', onclick: tryAgain }, 'Try again'),
        dashboard);

      card.replaceChildren(h('div', { class: 'apw-result' },
        h('div', { class: 'apw-hero' },
          h('div', { class: 'apw-icon ' + (success ? 'apw-ok' : 'apw-bad') },
            picture(success ? 'success-ring.svg' : 'fail-ring.svg', success ? 'success-ring-m.svg' : 'fail-ring.svg', 'apw-ring'),
            h('img', { class: 'apw-disc', src: assets(success ? 'success-disc.svg' : 'fail-disc.svg'), alt: '' }),
            glyph(success)),
          h('h2', { class: 'apw-title' }, success ? 'Payment Successful!' : state.unresolved ? 'Payment Status Unknown' : 'Payment Failed'),
          h('p', { class: 'apw-text' }, success
            ? 'Thank you for your purchase! Your payment has been confirmed.'
            : (result.message || "We couldn't process your payment. Please check your card details or try a different payment method."))),
        summary,
        actions));
    }

    // ------------------------------------------------------------ payment creation

    async function startPayment() {
      if (state.creating) return;
      state.creating = true;
      state.error = null;
      render();
      try {
        let merchantPaymentId;
        if (isLink) {
          freezePayment();
        } else {
          merchantPaymentId = typeof opts.merchantPaymentId === 'function'
            ? opts.merchantPaymentId(state.attempt)
            : opts.merchantPaymentId;
        }
        const res = await createSaleForm(merchantPaymentId);

        if (res.status === 201 || res.status === 202) {
          await handleCreated(res);
        } else if (res.status === 422) {
          fail('REJECTED', problemText(res.data));
        } else if (isLink && (res.status === 429 || res.status >= 500)) {
          // Nothing was created (or it is unknown): stay on the form and keep the identity for the next press.
          state.creating = false;
          state.error = res.status === 429
            ? 'Too many requests. Please wait a moment and try again.'
            : 'The payment service is temporarily unavailable. Please try again.';
          render();
        } else {
          fail(`HTTP_${res.status}`, problemText(res.data));
        }
      } catch (error) {
        if (signal.aborted) return;
        state.creating = false;
        state.error = 'Network error. Please check your connection and try again.';
        render();
      }
    }

    // Payment by Link: the request body belongs to one requestId. The same payload keeps the GUID (retries, reopening);
    // a changed payload (e.g. another typed amount) is a new intended payment and gets a new GUID.
    function freezePayment() {
      const core = JSON.stringify({ paymentLinkToken: opts.paymentLinkToken, amount: state.amount, payer: opts.payer });
      if (state.frozen && state.frozen.core === core) return;
      if (state.frozen) state.requestId = newRequestId();
      state.frozen = {
        core,
        body: JSON.stringify({
          paymentLinkToken: opts.paymentLinkToken,
          requestId: state.requestId,
          amount: state.amount,
          payer: opts.payer,
        }),
      };
    }

    function parseRetryAfter(response) {
      const seconds = Number(response.headers.get('Retry-After'));
      return Number.isFinite(seconds) && seconds > 0 ? Math.min(Math.ceil(seconds), 60) : null;
    }

    // One request ID is kept across transport retries so the backend de-duplicates the sale.
    async function createSaleForm(merchantPaymentId) {
      const body = isLink ? state.frozen.body : JSON.stringify({
        merchantId: opts.merchantId,
        merchantPaymentId,
        requestId: state.requestId,
        amount: state.amount,
        currency: opts.currency,
        description: opts.description,
        payer: opts.payer,
      });
      let lastError;
      for (let i = 0; i < CREATE_ATTEMPTS; i++) {
        if (i) await sleep(1000 * i, signal);
        try {
          const response = await fetch(opts.apiBaseUrl + (isLink ? LINK_SALE_FORM_PATH : SALE_FORM_PATH), {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body, signal,
          });
          if (response.status >= 500 && i < CREATE_ATTEMPTS - 1) {
            lastError = new Error(`HTTP ${response.status}`);
            continue;
          }
          let data = null;
          try { data = await response.json(); } catch { /* empty body */ }
          return { status: response.status, data, retryAfter: parseRetryAfter(response) };
        } catch (error) {
          if (signal.aborted) throw error;
          lastError = error;
        }
      }
      throw lastError || new Error('Network error');
    }

    async function handleCreated(res) {
      const data = res.data || {};
      const checkoutUrl = safeHttpUrl(data.checkoutUrl, opts.apiBaseUrl);
      const statusUrl = safeHttpUrl(data.statusUrl, opts.apiBaseUrl);
      if (!checkoutUrl || !statusUrl) {
        fail('UNAVAILABLE', 'The checkout could not be started. Please try again.');
        return;
      }
      state.session = {
        paymentOrderId: data.paymentOrderId,
        checkoutUrl: checkoutUrl.href,
        checkoutOrigin: checkoutUrl.origin,
        statusUrl: statusUrl.href,
        expiresAt: Date.parse(data.expiresAt) || null,
      };

      if (res.status === 201) {
        showCheckout();
        return;
      }

      const delay = (res.retryAfter || DEFAULT_RETRY_AFTER_S) * 1000;

      // Payment by Link, not yet sent to the PSP: status polling cannot finish it, only the identical POST can.
      if (isLink && UNDISPATCHED_STATES.includes(data.state)) {
        state.creatingPoll = true;
        scheduleReplay(delay);
        return;
      }

      // 202: creation is still resolving - poll the status URL until the checkout can be launched.
      state.creatingPoll = true;
      scheduleStatusPoll(delay);
    }

    // Repeats the identical creation POST (same GUID, frozen payload). Requests never overlap.
    function scheduleReplay(delay) {
      clearTimeout(state.replayTimer);
      if (state.closed || state.finished) return;
      state.replayTimer = setTimeout(replayCreate, delay);
    }

    async function replayCreate() {
      if (state.closed || state.finished || state.replaying) return;
      state.replaying = true;
      try {
        const res = await createSaleForm();
        state.replaying = false;
        if (state.closed || state.finished) return;
        if (res.status === 201 || res.status === 202) {
          await handleCreated(res);
        } else if (res.status === 422) {
          fail('REJECTED', problemText(res.data));
        } else if (res.status === 429 || res.status >= 500) {
          scheduleReplay((res.retryAfter || DEFAULT_RETRY_AFTER_S) * 1000);
        } else {
          fail(`HTTP_${res.status}`, problemText(res.data));
        }
      } catch (error) {
        state.replaying = false;
        if (signal.aborted) return;
        scheduleReplay(DEFAULT_RETRY_AFTER_S * 1000);
      }
    }

    // The outcome is not known (launch window over, status unreachable). It is not shown as a failure and no new
    // payment is offered, because the earlier attempt may still turn out to be paid.
    function unresolved(message) {
      if (state.finished || state.unresolved) return;
      state.unresolved = true;
      clearTimeout(state.pollTimer);
      clearTimeout(state.replayTimer);
      stopPopupWatch();
      state.creating = false;
      state.finishedAt = new Date();
      state.result = { paymentOrderId: state.session && state.session.paymentOrderId, code: 'UNRESOLVED', message };
      state.screen = 'failed';
      render();
    }

    function showCheckout() {
      if (isLink && state.session && state.session.expiresAt && Date.now() > state.session.expiresAt) {
        unresolved('The payment window has expired before the result was confirmed. If you were charged, the payment will be updated shortly. Please do not pay again.');
        return;
      }
      clearTimeout(state.replayTimer);
      state.creating = false;
      state.creatingPoll = false;
      state.screen = 'checkout';
      render();
      scheduleStatusPoll(POLL_INTERVAL_MS);
    }

    // ------------------------------------------------------------ status polling

    function scheduleStatusPoll(delay) {
      clearTimeout(state.pollTimer);
      if (state.closed || state.finished) return;
      state.pollTimer = setTimeout(pollStatus, delay);
    }

    async function pollStatus() {
      if (state.closed || state.finished || state.unresolved || state.polling || !state.session) return;
      state.polling = true;
      let next = state.creatingPoll ? DEFAULT_RETRY_AFTER_S * 1000 : POLL_INTERVAL_MS;
      try {
        const response = await fetch(state.session.statusUrl, { headers: { Accept: 'application/json' }, signal });
        // A missing status does not prove a failed payment in Payment by Link mode: keep checking until the window ends.
        if (response.status === 404 && !isLink) {
          fail('NOT_FOUND', null);
          return;
        }
        if (isLink && response.status === 429) next = (parseRetryAfter(response) || DEFAULT_RETRY_AFTER_S) * 1000;
        if (response.ok) {
          const status = await response.json();
          if (handleStatus(status)) return;
        }
        // other statuses (e.g. 503) are treated as transient
      } catch (error) {
        if (signal.aborted) return;
      } finally {
        state.polling = false;
      }

      const expiresAt = state.session.expiresAt;
      if (expiresAt && Date.now() > expiresAt + EXPIRY_GRACE_MS) {
        if (isLink) {
          // Launch expiry does not decide the outcome of a payment that may already have been sent to the PSP.
          unresolved('We could not confirm the result of your payment. If you were charged, it will be updated shortly. Please do not pay again.');
        } else {
          fail('EXPIRED', 'The payment session has expired.');
        }
        return;
      }
      scheduleStatusPoll(next);
    }

    // Returns true when polling is finished.
    function handleStatus(status) {
      if (!status) return false;
      if (status.expiresAt && state.session) state.session.expiresAt = Date.parse(status.expiresAt) || state.session.expiresAt;

      if (status.paymentState === 'Succeeded') {
        finish(true, status);
        return true;
      }
      if (status.terminal) {
        finish(false, status, status.creationState === 'Rejected' ? 'REJECTED' : String(status.paymentState || 'FAILED').toUpperCase());
        return true;
      }
      if (state.creatingPoll && status.launchAvailable) {
        showCheckout();
        return true;
      }
      return false;
    }

    function pollNow() {
      clearTimeout(state.pollTimer);
      pollStatus();
    }

    // ------------------------------------------------------------ finishing

    function finish(success, status, code, message) {
      if (state.finished) return;
      state.finished = true;
      clearTimeout(state.pollTimer);
      clearTimeout(state.replayTimer);
      stopPopupWatch();
      if (state.popup && !state.popup.closed) state.popup.close();
      state.popup = null;
      state.creating = false;
      state.finishedAt = new Date();
      state.result = {
        paymentOrderId: (status && status.paymentOrderId) || (state.session && state.session.paymentOrderId),
        code,
        message,
      };
      state.screen = success ? 'success' : 'failed';
      render();
      if (typeof opts.onComplete === 'function') {
        opts.onComplete({
          status: success ? 'succeeded' : 'failed',
          paymentOrderId: state.result.paymentOrderId,
          paymentState: status ? status.paymentState : null,
          creationState: status ? status.creationState : null,
          amount: state.amount,
          currency: opts.currency,
          code: code || null,
        });
      }
    }

    function fail(code, message) {
      finish(false, null, code, message);
    }

    function problemText(data) {
      return data && (data.detail || data.title) ? String(data.detail || data.title) : null;
    }

    // ------------------------------------------------------------ popup + messages

    function openPopup() {
      if (!state.session || state.finished) return;
      if (state.popup && !state.popup.closed) {
        state.popup.focus();
        return;
      }
      const popup = window.open(state.session.checkoutUrl, POPUP_NAME, POPUP_FEATURES);
      if (!popup) return; // blocked: the embedded form stays available
      state.popup = popup;
      state.popupNote = false;
      if (state.frame) state.frame.src = 'about:blank';
      render();
      stopPopupWatch();
      state.popupWatch = setInterval(() => {
        if (!state.popup || state.popup.closed) {
          stopPopupWatch();
          state.popup = null;
          state.popupNote = true; // closing the window is a UI event, not a payment failure
          if (!state.closed && !state.finished) render();
          pollNow();
        }
      }, 500);
    }

    function reopenEmbedded() {
      state.popupNote = false;
      render();
    }

    function stopPopupWatch() {
      clearInterval(state.popupWatch);
      state.popupWatch = null;
    }

    // The payload is advisory only: it triggers an immediate status check, the result comes from the backend.
    function onMessage(event) {
      const session = state.session;
      if (!session || event.origin !== session.checkoutOrigin) return;
      const fromFrame = state.frame && event.source === state.frame.contentWindow;
      const fromPopup = state.popup && event.source === state.popup;
      if (!fromFrame && !fromPopup) return;
      if (!event.data || event.data.type !== RETURN_MESSAGE_TYPE) return;
      pollNow();
    }

    // ------------------------------------------------------------ actions

    function tryAgain() {
      clearTimeout(state.pollTimer);
      state.finished = false;
      state.session = null;
      state.result = null;
      state.popupNote = false;
      state.attempt += 1;
      state.requestId = newRequestId();
      state.frozen = null; // an explicit new intended payment: new GUID, payload frozen again on the next press
      clearTimeout(state.replayTimer);
      state.creatingPoll = false;
      state.screen = 'summary';
      state.error = null;
      render();
    }

    function goToDashboard() {
      if (opts.dashboardUrl) {
        global.location.assign(opts.dashboardUrl);
        return;
      }
      close();
    }

    function close() {
      if (state.closed) return;
      state.closed = true;
      abort.abort();
      clearTimeout(state.pollTimer);
      clearTimeout(state.replayTimer);
      stopPopupWatch();
      window.removeEventListener('message', onMessage);
      document.removeEventListener('focusin', keepFocusInside);
      destroyLoader();
      if (!opts.container) document.body.style.overflow = previousOverflow;
      root.classList.add('apw-leaving');
      setTimeout(() => root.remove(), 220);
      if (typeof opts.onClose === 'function') {
        opts.onClose({
          paymentOrderId: state.session ? state.session.paymentOrderId : null,
          finished: state.finished,
          status: state.finished ? (state.screen === 'success' ? 'succeeded' : 'failed') : 'open',
        });
      }
    }

    return { close };
  }

  function normalizeOptions(options) {
    const o = options || {};
    if (!o.apiBaseUrl) throw new Error('apiBaseUrl is required');
    const linkMode = o.paymentLinkToken !== undefined && o.paymentLinkToken !== null && o.paymentLinkToken !== '';
    if (!linkMode) {
      if (o.merchantId === undefined || o.merchantId === null || o.merchantId === '') throw new Error('merchantId is required');
      if (!o.merchantPaymentId) throw new Error('merchantPaymentId is required');
    }
    if (!o.currency) throw new Error('currency is required');
    if (!o.payer || typeof o.payer !== 'object') throw new Error('payer is required');
    // null is treated like undefined (the PaymentLink page may pass a missing link amount as null)
    const amount = o.amount === null ? undefined : o.amount;
    if (amount !== undefined && !(Number(amount) > 0)) throw new Error('amount must be a positive number');

    return {
      apiBaseUrl: String(o.apiBaseUrl).replace(/\/$/, ''),
      paymentLinkToken: linkMode ? String(o.paymentLinkToken) : undefined,
      merchantId: o.merchantId,
      merchantPaymentId: o.merchantPaymentId,
      currency: String(o.currency).toUpperCase(),
      amount: amount === undefined ? undefined : Number(amount),
      description: o.description || 'Payment',
      payer: o.payer,
      minAmount: o.minAmount === undefined ? 1 : Number(o.minAmount),
      maxAmount: o.maxAmount === undefined ? 10000 : Number(o.maxAmount),
      termsUrl: o.termsUrl || '#',
      privacyUrl: o.privacyUrl || '#',
      dashboardUrl: o.dashboardUrl,
      container: o.container,
      assetsBaseUrl: o.assetsBaseUrl ? String(o.assetsBaseUrl).replace(/\/?$/, '/') : DEFAULT_ASSETS_BASE,
      onComplete: o.onComplete,
      onClose: o.onClose,
    };
  }

  // paymentLinks: open() accepts paymentLinkToken (Payment by Link mode). The PaymentLink page requires this exact marker.
  global.AltitudePayWidget = { open, capabilities: Object.freeze({ paymentLinks: true }) };
})(window);
